/** @module SiteAdmin/Locale/LocaleDependentTable */
define([
	"dojo/_base/declare",
	"csi/siteDefaultLocale",
	"csi/table/Widget"
], function(declare,siteDefaultLocale,TableWidget) {

	return declare(TableWidget, {
		/**
		 * @override
		 * Load site default localization resources 
		 */
		onViewStart: function(dfds) {
			dfds.push(siteDefaultLocale.initialize());
			this.inherited(arguments);
		}
	});
});